import React from 'react';
import PropTypes from 'prop-types';
import {
    AssignmentLateOutlined,
    BlockOutlined,
    DoneAllOutlined,
    HourglassEmptyOutlined
} from '@material-ui/icons';
import PageTitle from '../../shared/pagetitle/PageTitle.js';
import PainelLista from './PainelLista.jsx';
import {montarItensDocumentos} from './acompanhamentoEstatistico.js';
import {SEM_VALOR} from './inscricao/documentoInscricao.js';
import useCarregamentoPagina from './useCarregamentoPagina.js';
import useSWRFetch from '../../../hooks/useSWRFetch.js';
import {URL_ACOMPANHAMENTO_DOCUMENTOS} from '../../../constants/index.js';

const SWR_CONFIG = {revalidateOnFocus: false};
const PARAMS = {};

const ICONES_DOCUMENTOS = {
    APROVADO: DoneAllOutlined,
    NEGADO: BlockOutlined,
    PARA_ANALISAR: HourglassEmptyOutlined,
    COM_PENDENCIA: AssignmentLateOutlined
};

/*
 * Quadro "Documentos e Pendências" do processo de seleção escolhido (título e conteúdo; o Grid item é do
 * PainelEstatisticas e o Paper, da página). O loading da página é o LoadingModal global, via useCarregamentoPagina.
 */
export default function PainelDocumentos({idProcessoSeletivo}) {
    const {data, loading} = useSWRFetch(URL_ACOMPANHAMENTO_DOCUMENTOS(idProcessoSeletivo), PARAMS, SWR_CONFIG, undefined, true);
    useCarregamentoPagina(loading);
    // Enquanto não há dados, os valores mostram SEM_VALOR.
    const itens = montarItensDocumentos(data).map(item => ({
        ...item,
        valor: data ? item.valor : SEM_VALOR,
        Icon: ICONES_DOCUMENTOS[item.chave]
    }));

    return (
        <>
            <PageTitle title='Documentos e Pendências'/>
            <PainelLista itens={itens}/>
        </>
    );
}

PainelDocumentos.propTypes = {
    idProcessoSeletivo: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
